/**
 * <like-button>
 * -----------------------------------------------------------------------------
 *
 * @type {Component}
 *
 * -----------------------------------------------------------------------------
 */

parasails.registerComponent('like-button', {

  //  ╔═╗╦ ╦╔╗ ╦  ╦╔═╗  ╔═╗╦═╗╔═╗╔═╗╔═╗
  //  ╠═╝║ ║╠╩╗║  ║║    ╠═╝╠╦╝║ ║╠═╝╚═╗
  //  ╩  ╚═╝╚═╝╩═╝╩╚═╝  ╩  ╩╚═╚═╝╩  ╚═╝
  props: [
    'event_id',
    'icon_image',
    'icon_name',
    'part_id',
    'click_buffer_time',
    'is_charge_mode',
    'device_id',
    'charge_color'
  ],

  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╦╔╗╔╔╦╗╔═╗╦═╗╔╗╔╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ║║║║ ║ ║╣ ╠╦╝║║║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╩╝╚╝ ╩ ╚═╝╩╚═╝╚╝╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: function () {
    return {
      isPressed: false,
      buttonStyle: 'width: 80% !important;',
      buttonUpStyle: '',
      clickStyleNormal: 'width: 80% !important;',
      clickStyleSmall: 'width: 45% !important;',
      clickStyleXSmall: 'width: 45% !important;',
      chargeClassOn: 'chargemode',
      chargeClassOff: 'chargemodeoff',
      chargeClassCurrent: 'chargemodeoff',
      countDown: 0,
      immediate: false,
      iconClicks: {},
      clickStart: new Date(),
      maxHold: 3,
      containerIsActive: false
    };
  },


  //  ╦ ╦╔╦╗╔╦╗╦
  //  ╠═╣ ║ ║║║║
  //  ╩ ╩ ╩ ╩ ╩╩═╝
  template: `
    <div class="like-button" :class="{ 'stamp-container': is_charge_mode, 'is-active': containerIsActive }">
      <img v-show="is_charge_mode === false" :src="this.icon_image.startsWith('http') ? this.icon_image : ('/images/icons/' + this.icon_image)" v-on:click.stop="emptyFunk" v-on:mousedown.stop="emptyFunk" v-on:mouseup.stop="emptyFunk" v-on:touchstart.stop="emptyFunk" v-on:touchend.stop="emptyFunk" v-on:pointerdown.stop="press" v-on:pointerup.stop="release" :style="this.buttonStyle" />
      <img v-show="is_charge_mode === true" :src="this.icon_image.startsWith('http') ? this.icon_image : ('/images/icons/' + this.icon_image)" :class="this.buttonUpStyle" :style="this.buttonStyle" v-on:click.stop="emptyFunk" v-on:mousedown.stop="emptyFunk" v-on:mouseup.stop="emptyFunk" v-on:touchstart.stop="emptyFunk" v-on:touchend.stop="emptyFunk" v-on:pointerdown.stop="emptyFunk" v-on:pointerup.stop="emptyFunk"/>
      <svg v-show="is_charge_mode === true" :class="chargeClassCurrent" v-on:click.stop="emptyFunk" v-on:mousedown.stop="emptyFunk" v-on:mouseup.stop="emptyFunk" v-on:touchstart.stop="emptyFunk" v-on:touchend.stop="emptyFunk" v-on:pointerdown.stop="press" v-on:pointerup.stop="release" xmlns="http://www.w3.org/2000/svg" width="300" height="300" viewBox="0 0 512 512"><path d="M256,9.46c141.88,0,245.98,113.7,245.98,246.54s-106.31,246.31-246.31,246.31S10.18,390.11,10.18,256,120.6,9.46,256,9.46Z" fill="none" :stroke="charge_color" stroke-miterlimit="10" stroke-width="7"/></svg>
    </div>
    `,


  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  mounted: async function() {
    this.buttonStyle = this.clickStyleNormal;
    if(this.click_buffer_time) {
      this.immediate = (!isNaN(this.click_buffer_time) && this.click_buffer_time <= 0);
    } else {
      this.immediate = true;
    }
    if(this.immediate === false) {
      this.countDown = this.click_buffer_time;
      this.sendClick();
    }
  },

  beforeDestroy: function() {

  },

  watch: {

  },

  computed: {

  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {

    likeClicked: function () {
      if(this.icon_name === 'fireworks' || this.is_charge_mode === false) {
        if(this.immediate === false) {
          this.iconClicks[this.icon_name] = (!this.iconClicks[this.icon_name]) ? 1 : this.iconClicks[this.icon_name] + 1;
        }
        if(this.icon_name !== 'fireworks') {
          this.$emit('like-clicked');
        } else {
          this.$emit('firework-activated');
        }
        if(this.immediate === true) {
          io.socket.post('/like', { eventid: this.event_id, partID: this.part_id , likeType: this.icon_name, clickCount: this.clickCountTracker, deviceID: this.device_id});
        }
      }
    },

    sendClick: function() {
      this.countDown--;
      if(this.countDown > 0) {
        setTimeout(() => {
          const keys = Object.keys(this.iconClicks);
          keys.forEach((key, index) => {
            if(this.iconClicks[key] > 0) {io.socket.post('/like', { eventid: this.event_id, partID: this.part_id , likeType: key, clickCount: this.iconClicks[key], deviceID: this.device_id});}
            delete this.iconClicks[key];
          });
          this.countDown = this.click_buffer_time;
          if(this.immediate === false) {this.sendClick();}
        }, this.click_buffer_time * 1000);
      }
    },

    press: function(){
      this.isPressed = true;
      this.clickStart = new Date();
      this.buttonUpStyle = '';
      this.chargeClassCurrent = this.chargeClassOff;

      // Set to small first
      if(this.icon_name !== 'fireworks' && this.is_charge_mode === true) {
        this.buttonStyle = this.clickStyleSmall;
      } else {
        this.buttonStyle = (this.icon_name === 'fireworks') ? this.clickStyleSmall : this.clickStyleSmall;
      }

      // After the shrink has been applied, start the charge circle and the growth
      this.$nextTick(() => {
        this.chargeClassCurrent = this.chargeClassOn;
        this.containerIsActive = true;
      });
    },

    emptyFunk: function() {},

    release: function() {
      this.isPressed = false;
      this.containerIsActive = false;
      this.chargeClassCurrent = this.chargeClassOff;
      if(this.icon_name !== 'fireworks' && this.is_charge_mode === true) {
        //Charge value is measured as a percentage of the max (not added yet)
        var chargePercentage = 100.0;
        var seconds = (new Date().getTime() - this.clickStart.getTime()) / 1000;
        if(seconds >= this.maxHold) {
          chargePercentage = 100;
        } else if(seconds <= 1) {
          chargePercentage = 1;
        } else {
          chargePercentage = (seconds / this.maxHold) * 100;
        }
        this.$emit('like-clicked');
        io.socket.post('/like', { eventid: this.event_id, partID: this.part_id , likeType: this.icon_name, chargeValue: chargePercentage, deviceID: this.device_id});
        this.buttonStyle = this.clickStyleNormal;
        if (seconds > 0.1) {
          //this.buttonUpStyle = 'goUp';
          const rect = this.$el.getBoundingClientRect();
          const newStamp = document.createElement('img');
          newStamp.src = this.icon_image.startsWith('http') ? this.icon_image : ('/images/icons/' + this.icon_image);
          newStamp.style.position = 'fixed';
          newStamp.style.left = rect.left + 'px';
          newStamp.style.top = rect.top + 'px';
          newStamp.style.pointerEvents = 'none';
          newStamp.classList.add('goUpAndAway');
          document.body.appendChild(newStamp);

          setTimeout(() => {
            newStamp.remove();
          }, 500); // Remove after 0.5 second, which is the animation duration
          
          // Let the parent know the animation is done so it can reset us
          setTimeout(() => {
            this.$emit('animation-finished');
          }, 500); // Duration of the goUpAnimation
        } else {
          this.buttonUpStyle = '';
        }
      } else if(this.icon_name === 'fireworks') {
        this.$emit('firework-activated');
        io.socket.post('/like', { eventid: this.event_id, partID: this.part_id , likeType: this.icon_name, chargeValue: 0, deviceID: this.device_id});
        this.buttonStyle = this.clickStyleNormal;
      } else {
        io.socket.post('/like', { eventid: this.event_id, partID: this.part_id , likeType: this.icon_name, chargeValue: 0, deviceID: this.device_id});
        this.buttonStyle = this.clickStyleNormal;
      }
    }
  }
});